var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bullet",class:{ positive: _vm.value === true && _vm.positive, negative: _vm.value === false && !_vm.positive },on:{"click":_vm.changeHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }